@if (featureEnabled) {
  <p-accordion-panel value="1">
    <p-accordion-header>Ad Rules</p-accordion-header>
    <p-accordion-content>
      <tr class="p-grid form-row" title="Vehicle Ad Rules">
        <td class="p-col-1">
          <button pButton type="button" class="p-button-success" label="Add" (click)="addRule()"></button>
        </td>
        <td class="p-col-8">
          <!--      <button pButton type="button" class="p-button-info" label="Set Active/Inactive" (click)="toggleRulesActive()"></button>-->
        </td>
        <td class="p-col-2">
          @if (anySelected()) {
            <button pButton type="button" class="p-button-danger" label="Delete Selected" (click)="openDeleteSelectedOfferRulesModal()">
            </button>
          }
        </td>
      </tr>
      @if (isRulesLoaded) {
        <div [formGroup]="offerRulesForm">
          <div formArrayName="rules">
            <tr class="p-grid p-justify-even form row">
              <td class="p-col-1 center-checkbox position-relative">
                <p-checkbox binary="true" (onChange)="selectAll()"></p-checkbox>
                <div class="label-below"><small class="checkbox-label">{{ allSelected ? 'Deselect All' : 'Select All' }}</small></div>
              </td>
              <th class="p-col-2">Ad Data</th>
              <th class="p-col-3">Operator</th>
              <th class="p-col-2">Value</th>
              <th class="p-col-3">Action</th>
              <th class="p-col-1"></th>
            </tr>
            @for (rule of rules.controls; track rule; let idx = $index) {
              <div class="p-grid p-justify-center p-align-center p-justify-even form-row" [formGroupName]="idx">
                <td class="p-col-1 center-checkbox">
                  <p-checkbox binary="true" formControlName="selected"></p-checkbox>
                </td>
                <td class="p-col-2 position-relative">
                  <p-select [options]="adDataOptions" formControlName="adDataOption" placeholder="Select an Option" (onChange)="updateDataType(rule)"></p-select>
                  @if (rule.get('adDataOption').invalid && rule.get('adDataOption').touched) {
                    <div>
                      <small class="invalid-text">Selected is required.</small>
                    </div>
                  }
                </td>
                <td class="p-col-3 position-relative">
                  <p-select [options]="rule.value.operators" formControlName="selectedOperator" placeholder="Select an Option"></p-select>
                  @if (rule.get('selectedOperator').invalid && rule.get('selectedOperator').touched) {
                    <div>
                      <small class="invalid-text">Operator is required.</small>
                    </div>
                  }
                </td>
                <td class="p-col-2 position-relative">
                  <div class="value-container">
                    @if (rule.get('dataType')?.value === 'dollar') {
                      <span class="value-prefix">$</span>
                    }
                    <input pInputText
                           id="value"
                           size="5"
                           formControlName="value"/>
                    @if (rule.get('dataType')?.value === 'percent') {
                      <span class="value-suffix">%</span>
                    }
                  </div>
                  @if (rule.get('value').invalid && rule.get('value').touched) {
                    <div>
                      <small class="invalid-text">Invalid Value.</small>
                    </div>
                  }
                </td>
                <td class="p-col-3 position-relative">
                  <p-select [options]="actionOptions" formControlName="action" placeholder="Select an Option"></p-select>
                  @if (rule.get('action').invalid && rule.get('action').touched) {
                    <div>
                      <small class="invalid-text">Action is required.</small>
                    </div>
                  }
                </td>
                <td class="p-col-1 position-relative">
                  <button pButton type="button" class="p-button-danger p-button-icon" (click)="openDeleteOfferRuleModal(idx)">
                    <i class="pi pi-trash"></i>
                  </button>
                </td>
              </div>
            }
            @if (rules.controls.length === 0) {
              <tr class="p-grid p-justify-even">
                <div class="label-below no-rules">No Ad Rules created yet.</div>
              </tr>
            }
          </div>
        </div>
      }
      <div class="modal-button-wrapper">
        <p-confirmDialog key="deleteOfferRule"></p-confirmDialog>
      </div>
      <div class="modal-button-wrapper">
        <p-confirmDialog key="deleteSelectedOfferRules"></p-confirmDialog>
      </div>
    </p-accordion-content>
  </p-accordion-panel>
}
